import { BigNumber } from 'bignumber.js'

var orgDiv = BigNumber.prototype.div,
    orgIdiv = BigNumber.prototype.idiv,
    orgDividedBy = BigNumber.prototype.dividedBy,
    orgDividedToIntegerBy = BigNumber.prototype.dividedToIntegerBy,
    orgTimes = BigNumber.prototype.times,
    orgPlus = BigNumber.prototype.plus,
    orgMinus = BigNumber.prototype.minus

function isEmpty(n) {
    return (
        n === null ||
        n === undefined ||
        n === '' ||
        (n._isBigNumber && n.isNaN())
    )
}

// mutate 处理常见边际情况
// plus、minus 遇到空值视为0
// times、div 遇到空值视为1
Object.assign(BigNumber.prototype, {
    // 用于track比较
    getTrackValue() {
        return this.toString()
    },

    // 除
    div(n, base) {
        n = isEmpty(n) ? 1 : n

        return orgDiv.call(this, n, base)
    },
    //dividedToIntegerBy
    idiv(n, base) {
        n = isEmpty(n) ? 1 : n

        return orgIdiv.call(this, n, base)
    },
    //same as div(alias)
    dividedBy(n, base) {
        n = isEmpty(n) ? 1 : n

        return orgDividedBy.call(this, n, base)
    },
    // same as idiv(alias)
    dividedToIntegerBy(n, base) {
        n = isEmpty(n) ? 1 : n

        return orgDividedToIntegerBy.call(this, n, base)
    },
    // 乘
    times(n, base) {
        n = isEmpty(n) ? 1 : n

        return orgTimes.call(this, n, base)
    },
    // 加
    plus(n, base) {
        n = isEmpty(n) ? 0 : n

        return orgPlus.call(this, n, base)
    },
    // 减
    minus(n, base) {
        n = isEmpty(n) ? 0 : n

        return orgMinus.call(this, n, base)
    },
})

if (process.env.NODE_ENV === 'development') {
    window.Num = BigNumber
}

export default BigNumber
